/* BACHCA - Barre COMMANDER flottante (mobile) : apparait en bas quand le vrai bouton sort de l'ecran */
if (!customElements.get('sticky-checkout')) {
  customElements.define(
    'sticky-checkout',
    class StickyCheckout extends HTMLElement {
      connectedCallback() {
        const form = this.closest('form');
        if (!form) return;
        this.realBtn = form.querySelector('.mini-cart__footer .button[name="checkout"]');
        this.scroller = form.querySelector('.mini-cart__inner');
        if (!this.realBtn || !this.scroller) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // afficher la barre flottante quand le vrai bouton n'est PAS visible
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { root: this.scroller, threshold: 0.05 }
        );
        this.observer.observe(this.realBtn);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
